import { LEVELS, WORLDS } from '../sim/levels';
import { store } from '../store';
import { $, el, starsEl } from './dom';

/** A level opens once the one before it has at least one star. */
export function isUnlocked(index: number, stars: Record<string, number>): boolean {
  return index === 0 || (stars[LEVELS[index - 1].id] ?? 0) > 0;
}

export function renderAdventure(onPick: (levelId: string) => void): void {
  const stars = store.stars();
  const total = LEVELS.reduce((n, l) => n + (stars[l.id] ?? 0), 0);
  $('advSummary').textContent = `${total} de ${LEVELS.length * 3} estrellas. Cada mundo termina con un jefe.`;
  const worlds = WORLDS.map((w) => {
    const levels = LEVELS.map((l, i) => ({ l, i })).filter(({ l }) => l.world === w.n);
    const grid = el('div', { class: 'levels' });
    for (const { l, i } of levels) {
      const open = isUnlocked(i, stars);
      const b = el('button', {
        class: l.boss ? 'level-btn boss' : 'level-btn',
        attrs: {
          type: 'button',
          'aria-label': `Nivel ${l.id}, ${l.name}${l.boss ? ', jefe' : ''}${open ? `, ${stars[l.id] ?? 0} estrellas` : ', bloqueado'}`,
        },
      }, [l.id, starsEl(stars[l.id] ?? 0, 3, 'small'), el('span', { class: 'lvl-name', text: l.name })]);
      b.disabled = !open;
      b.addEventListener('click', () => onPick(l.id));
      grid.append(b);
    }
    return el('section', { class: 'world' }, [el('h3', { text: `Mundo ${w.n}` }, [el('small', { text: w.name })]), grid]);
  });
  $('worlds').replaceChildren(...worlds);
}
